<template>
  <Walkthrough 
    roomName="Büro"
    roomKey="office"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="german"
  />
</template>
<script>

export default {
  name: 'Oficina',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/office-1920x1280.jpg",
      steps: [
        "Blicke nach links und dann zum Schreibtisch.",
        "Jetzt, wo du weißt, dass ein Brief auf dem Schreibtisch liegt, blicke den Brief an.",
        "In dem Brief sind Hinweise zur Sicherung. Merk dir die vier Objekte, die im Brief erwähnt werden, und auch ihre Reihenfolge. Dann blicke diese Objekte im Raum an und identifiziere ihre Farben.",
        "Da du jetzt die vier Farben kennst, schau nach rechts und inspiziere die Sicherung. Du kannst nun die Farben Grün, Rot, Blau, Weiß eingeben und der Strom sollte anfangen zu fließen. Das wird sich später als nützlich erweisen.",
        "Schau jetzt nach unten und überprüfe die Falltür. Darin findest du ein Brecheisen.",
        "Schau nach links und öffne mit dem Brecheisen die Schublade. Du findest einen Schraubenzieher in der Schublade.",
        "Schau nach oben und öffne mit dem Schraubenzieher die Lüftung. Darin findest du einen Hammer.",
        "Schau nach links und benutze den Hammer, um den dicken Glasrahmen um das Foto herum zu zerbrechen. Dadurch wird eine Nachricht auf der Rückseite enthüllt.",
        "Mit der Nachricht, die du auf der Rückseite des Fotos gefunden hast, kannst du das Alter der Tochter (5 Jahre) und das Datum des Fotos (1995) als Code für den Safe verwenden: 0390 (Geburtstag der Tochter, März 1990)",
        "Schau jetzt nach rechts und betrachte den Safe. Du musst den Code 0390 eingeben und den letzten Schlüssel finden!",
        "Mit dem Schlüssel kannst du nun nach vorne schauen, die Tür aufschließen und in die Freiheit entkommen. Glückwunsch, du bist geflohen! Versuche, den nächsten Raum alleine zu lösen!",
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/de/office.vue